import { render, staticRenderFns } from "./NodeIcon.vue?vue&type=template&id=040ef026&scoped=true&lang=pug"
import script from "./NodeIcon.vue?vue&type=script&lang=js"
export * from "./NodeIcon.vue?vue&type=script&lang=js"
import style0 from "./NodeIcon.vue?vue&type=style&index=0&id=040ef026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ef026",
  null
  
)

export default component.exports